import { GlobalWorkerOptions, getDocument } from 'pdfjs-dist/build/pdf.js';
import { EventBus, PDFLinkService, PDFFindController, PDFViewer } from 'pdfjs-dist/web/pdf_viewer.js';
import * as pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import 'pdfjs-dist/web/pdf_viewer.css';
import screenfull from 'screenfull';

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var script = {
  name: 'controlPage',
  props: [
    'totalPageNum',
    'curPageNum',
    'setPage',
  ],
  data() {
    return {
      isEmpty: false // 允许用户输入为空
    }
  },
  methods: {
    pageTo(relativeNum) {
      const num = Number(this.curPageNum) + relativeNum;
      if (num <= 0 || num >= this.totalPageNum) {
        return
      }
      this.isEmpty = false;
      this.change(num);
    },
    change(inputString) {
      const num = Number(inputString);
      if (!inputString) {
        this.isEmpty = true;
      } else {
        this.isEmpty = false;
        this.setPage(num);
      }
    }
  },
  computed: {
    showPageNum() {
      return this.isEmpty ? '' : this.curPageNum
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "page" }, [
    _c("i", {
      staticClass: "el-icon-arrow-left icon-hover",
      on: {
        click: function($event) {
          return _vm.pageTo(-1)
        }
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "wrap" }, [
      _c(
        "div",
        { staticClass: "input" },
        [
          _c("el-input", {
            attrs: { value: _vm.showPageNum },
            on: { input: _vm.change }
          })
        ],
        1
      ),
      _vm._v("\n    / " + _vm._s(_vm.totalPageNum) + "\n  ")
    ]),
    _vm._v(" "),
    _c("i", {
      staticClass: "el-icon-arrow-right icon-hover",
      on: {
        click: function($event) {
          return _vm.pageTo(1)
        }
      }
    })
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-95f4c734";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var script$1 = {
  name: 'controlZoom',
  props: [
    'setZoom',
    'showScale',
  ],
  data() {
    return {
    }
  },
  methods: {
    zoom(data) {
      const nextScale = parseFloat((this.scale + data) / 100).toFixed(1);
      this.setZoom(nextScale);
    },
  },
  computed: {
    scale() {
      return parseInt(parseFloat(this.showScale).toFixed(1) * 100)
    }
  }
};

/* script */
const __vue_script__$1 = script$1;
/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("span", { staticClass: "zoom" }, [
    _c("i", {
      staticClass: "el-icon-remove-outline icon-hover",
      on: {
        click: function($event) {
          return _vm.zoom(-10)
        }
      }
    }),
    _vm._v(" "),
    _c("span", { staticClass: "value" }, [_vm._v(_vm._s(_vm.scale) + "%")]),
    _vm._v(" "),
    _c("i", {
      staticClass: "el-icon-circle-plus-outline icon-hover",
      on: {
        click: function($event) {
          return _vm.zoom(10)
        }
      }
    })
  ])
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = "data-v-1b508ce3";
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    undefined,
    undefined,
    undefined
  );

/**
 * TODO 这里其实是单例模式，但是从调用方式上没有体现出来
 * 这里应该不允许使用new 都通过getInstance 静态方法来实现
 * 如何使用new 的时候报错，就像Symobl一样
 */
class PdfView {
  pdfViewer // pdfViewer 实例
  eventBus // 监听事件
  pdfLinkService // (Optionally) enable hyperlinks within PDF files.
  pdfFindController // (Optionally) enable find controller.
  pdfDoc // pdfDOC 文档
  domID // pdfDOC 文档
  wrapDOM // 包裹的DOM
  static instance
  constructor(props) {
    if (PdfView.instance) {
      return PdfView.instance
    } else {
      this.domID = props.id;
      this._initVar();
      PdfView.instance = this;
    }
  }

  // 初始化变量
  _initVar = () => {
    GlobalWorkerOptions.workerSrc = pdfjsWorker;

    this.eventBus = new EventBus();
    // (Optionally) enable hyperlinks within PDF files.
    this.pdfLinkService = new PDFLinkService({
      eventBus: this.eventBus
    });
    // (Optionally) enable find controller.
    this.pdfFindController = new PDFFindController({
      eventBus: this.eventBus,
      linkService: this.pdfLinkService
    });
  }

  // mounted 之后执行
  initViewer = async (url, callback) => {
    const initDocs = async url => {
      // Loading document.
      const loadingTask = getDocument({
        url: url,
        // 这里会懒加载？
        eventBusDispatchToDOM: true,
        cMapPacked: true,
        cMapUrl: '../../../../../node_modules/pdfjs-dist/cmaps/'
      });
      this.pdfDoc = await loadingTask.promise;
      // Document loaded, specifying document for the viewer and
      // the (optional) linkService.
      this.pdfViewer.setDocument(this.pdfDoc);
      this.pdfLinkService.setDocument(this.pdfDoc, null);
      // await loadingTask.promise.then((pdfDocument) => {
      //   this.pdfDoc = pdfDocument
      //   // Document loaded, specifying document for the viewer and
      //   // the (optional) linkService.
      //   this.pdfViewer.setDocument(pdfDocument)
      //   this.pdfLinkService.setDocument(pdfDocument, null)
      // })
    };
    const initPageEvt = () => {
      this.eventBus.on('pagesinit', () => {
        // We can use pdfViewer now, e.g. let's change default scale.
        this.pdfViewer.currentScaleValue = 'page-width';
        callback(this.pdfViewer.currentScale);
      });
    };
    this.wrapDOM = document.getElementById(this.domID);
    this.pdfViewer = new PDFViewer({
      container: this.wrapDOM,
      eventBus: this.eventBus,
      linkService: this.pdfLinkService,
      findController: this.pdfFindController
    });
    this.pdfLinkService.setViewer(this.pdfViewer);
    initPageEvt();
    initDocs(url);
    return {
      showScale: this.pdfViewer.currentScale
    }
  }

  addPageRenderEvt = callback => {
    // 渲染页面时执行的函数
    this.eventBus.on('textlayerrendered', evt => {
      const { pageNumber, source } = evt;
      const { viewport, textLayerDiv } = source;
      callback(pageNumber, textLayerDiv, viewport);
    });
  }

  addPageChangeEvt = callback => {
    // 渲染页面时执行的函数
    this.eventBus.on('pagechanging', evt => {
      const page = evt.pageNumber;
      callback(page);
    });
  }
  setZoom = showScale => {
    this.pdfViewer.currentScale = showScale;
  }
  setPage = (curPageNum, toTop) => {
    /**
     * 可能页面还没有渲染出来，所以需要先渲染
     */
    this.pdfDoc.getPage(curPageNum).then(() => {
      this.pdfViewer.currentPageNumber = curPageNum;
      if (toTop) {
        const currentTop = this.wrapDOM.scrollTop;
        this.wrapDOM.scroll({
          top: currentTop + toTop
          // behavior: 'smooth',
        });
      }
    });
  }
  // 点击目录进行跳转
  jumpPage = data => {
    this.pdfViewer.jumpPage(data);
  }
  searchKeywords = data => {
    this.pdfFindController.executeCommand('find', data);
  }
  addFindEvt = callback => {
    this.eventBus.on('updatefindcontrolstate', e => {
      callback(e.matchesCount.current, e.matchesCount.total);
    });

    this.eventBus.on('updatefindmatchescount', e => {
      callback(e.matchesCount.current, e.matchesCount.total);
    });
  }
  findAgain(data, boo) {
    this.pdfFindController.executeCommand('findagain', {
      ...data,
      findPrevious: boo
    });
  }
  getPage(pageIndex) {
    return this.pdfDoc.getPage(pageIndex)
  }
}

//
var script$2 = {
  name: 'FindKey',
  created() {
    this.pdfViewerInstance = new PdfView();
    this.pdfViewerInstance.addFindEvt(this.updateIdx);
  },
  components: {
  },
  data() {
    return {
      currentIndex: 0,
      findTotal: 0,
      pdfViewerInstance: null,
      searchState: {
        query: '',
        caseSensitive: false,
        highlightAll: false,
        phraseSearch: true,
      }
    }
  },
  methods: {
    handleSearch() {
      const data = this.searchState;
      this.pdfViewerInstance.searchKeywords(data);
      if (!data.query) ;
    },
    setConfig(field) {
      this.searchState[field] = !this.searchState[field];
      this.pdfViewerInstance.searchKeywords(this.searchState);
    },
    updateIdx(curIdx, findTotal) {
      this.currentIndex = curIdx;
      this.findTotal = findTotal;
    },
    next(data, boo) {
      this.pdfViewerInstance.findAgain(data, boo);
    },
  }
};

/* script */
const __vue_script__$2 = script$2;
/* template */
var __vue_render__$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    [
      _c(
        "el-popover",
        { attrs: { placement: "bottom-start", trigger: "click" } },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "align-items": "center" } },
            [
              _c(
                "el-input",
                {
                  staticClass: "input-with-select",
                  staticStyle: { "margin-right": "10px" },
                  attrs: {
                    size: "mini",
                    placeholder: "请输入内容",
                    clearable: ""
                  },
                  on: { clear: _vm.handleSearch },
                  nativeOn: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.handleSearch.apply(null, arguments)
                    }
                  },
                  model: {
                    value: _vm.searchState.query,
                    callback: function($$v) {
                      _vm.$set(_vm.searchState, "query", $$v);
                    },
                    expression: "searchState.query"
                  }
                },
                [
                  _c("el-button", {
                    staticClass: "icon-hover",
                    attrs: {
                      slot: "append",
                      size: "mini",
                      icon: "el-icon-caret-bottom"
                    },
                    on: {
                      click: function($event) {
                        return _vm.next(_vm.searchState, false)
                      }
                    },
                    slot: "append"
                  }),
                  _vm._v(" "),
                  _c("el-button", {
                    staticClass: "icon-hover",
                    attrs: {
                      slot: "append",
                      size: "mini",
                      icon: "el-icon-caret-top"
                    },
                    on: {
                      click: function($event) {
                        return _vm.next(_vm.searchState, true)
                      }
                    },
                    slot: "append"
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "mini",
                    type: _vm.searchState.highlightAll ? "primary" : ""
                  },
                  on: {
                    click: function($event) {
                      return _vm.setConfig("highlightAll")
                    }
                  }
                },
                [_vm._v("\n        高亮全部\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: _vm.searchState.caseSensitive ? "primary" : "",
                    size: "mini"
                  },
                  on: {
                    click: function($event) {
                      return _vm.setConfig("caseSensitive")
                    }
                  }
                },
                [_vm._v("\n        区分大小写\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "mini",
                    type: _vm.searchState.phraseSearch ? "primary" : ""
                  },
                  on: {
                    click: function($event) {
                      return _vm.setConfig("phraseSearch")
                    }
                  }
                },
                [_vm._v("\n        字词匹配\n      ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    "white-space": "nowrap",
                    "margin-left": "10px"
                  }
                },
                [
                  _vm._v(
                    "\n        第 " +
                      _vm._s(_vm.currentIndex) +
                      " 项\\共匹配 " +
                      _vm._s(_vm.findTotal) +
                      " 项\n      "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("i", {
            staticClass: "el-icon-search icon-hover",
            attrs: { slot: "reference" },
            slot: "reference"
          })
        ]
      )
    ],
    1
  )
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = "data-v-a4e11236";
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$2 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    undefined,
    undefined,
    undefined
  );

//

var script$3 = {
  name: 'ControlBar',
  data() {
    return {
      currentIndex: 0,
      findTotal: 0,
      baseScale: 0,
    }
  },
  props: [
    'totalPageNum',
    'showScale',
    'curPageNum',
    'setZoom',
    'setPage',
  ],
  components: {
    ControlPage: __vue_component__,
    FindKey: __vue_component__$2,
    ControlZoom: __vue_component__$1
  },
  methods: {
    toScreenFull() {
      const dom = document.querySelector('.view-wrap');
      screenfull.isEnabled && screenfull.toggle(dom);
    }
  }
};

/* script */
const __vue_script__$3 = script$3;
/* template */
var __vue_render__$3 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "control" }, [
    _c(
      "div",
      { staticClass: "left" },
      [
        _c("FindKey"),
        _vm._v(" "),
        _c("ControlZoom", {
          attrs: { setZoom: _vm.setZoom, showScale: _vm.showScale }
        }),
        _vm._v(" "),
        _c("ControlPage", {
          attrs: {
            totalPageNum: _vm.totalPageNum,
            curPageNum: _vm.curPageNum,
            setPage: _vm.setPage
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("i", {
      staticClass: "el-icon-full-screen icon",
      on: { click: _vm.toScreenFull }
    })
  ])
};
var __vue_staticRenderFns__$3 = [];
__vue_render__$3._withStripped = true;

  /* style */
  const __vue_inject_styles__$3 = undefined;
  /* scoped */
  const __vue_scope_id__$3 = "data-v-5fe4ce7e";
  /* module identifier */
  const __vue_module_identifier__$3 = undefined;
  /* functional template */
  const __vue_is_functional_template__$3 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$3 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$4 = {
  name: 'unhold-comp',
  props: {
    pos: {
      type: String,
      default: 'left',
      validator: function (value) {
        // 这个值必须匹配下列字符串中的一个
        return ['left', 'right'].indexOf(value) !== -1
      }
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      show: false,
    }
  },
  methods: {
    click () {
      this.show = !this.show;
    }
  }
};

/* script */
const __vue_script__$4 = script$4;
/* template */
var __vue_render__$4 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { class: (_vm.show ? "unhold-wrap " : "unhold-wrap hidden ") + _vm.pos },
    [
      _c("div", { staticClass: "tip", on: { click: _vm.click } }, [
        _vm._v("\n    " + _vm._s(_vm.title) + "\n  ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.show ? "content op1" : "content op0" },
        [_vm._t("default")],
        2
      )
    ]
  )
};
var __vue_staticRenderFns__$4 = [];
__vue_render__$4._withStripped = true;

  /* style */
  const __vue_inject_styles__$4 = undefined;
  /* scoped */
  const __vue_scope_id__$4 = "data-v-4291a246";
  /* module identifier */
  const __vue_module_identifier__$4 = undefined;
  /* functional template */
  const __vue_is_functional_template__$4 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$4 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    false,
    undefined,
    undefined,
    undefined
  );

//
var script$5 = {
  name: 'pdf-directory',
  components: {
    UnholdComp: __vue_component__$4
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    jumpPage: {
      type: Function
    },
    pos: {
      type: String,
      default: 'left',
      validator: function (value) {
        // 这个值必须匹配下列字符串中的一个
        return ['left', 'right'].indexOf(value) !== -1
      }
    }
  },
  data() {
    return {
      props: {
        label: 'name',
        isLeaf: 'leaf'
      },
    }
  },
  methods: {
    handleClick(data) {
      if (data && data.toTop >= 0 && data.number) {
        this.jumpPage(data.number, data.toTop - 60 || 0);
      }
    },
  },
};

/* script */
const __vue_script__$5 = script$5;
/* template */
var __vue_render__$5 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("UnholdComp", { attrs: { title: "目录", pos: _vm.pos } }, [
    _c("div", { staticClass: "directory" }, [
      _c("div", { staticClass: "label" }, [_vm._v("目录")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tree" },
        [
          _c("el-tree", {
            attrs: {
              "default-expanded-keys": [1, 2],
              props: _vm.props,
              data: _vm.data
            },
            on: { "node-click": _vm.handleClick }
          })
        ],
        1
      )
    ])
  ])
};
var __vue_staticRenderFns__$5 = [];
__vue_render__$5._withStripped = true;

  /* style */
  const __vue_inject_styles__$5 = undefined;
  /* scoped */
  const __vue_scope_id__$5 = "data-v-78c8e84c";
  /* module identifier */
  const __vue_module_identifier__$5 = undefined;
  /* functional template */
  const __vue_is_functional_template__$5 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$5 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
    __vue_inject_styles__$5,
    __vue_script__$5,
    __vue_scope_id__$5,
    __vue_is_functional_template__$5,
    __vue_module_identifier__$5,
    false,
    undefined,
    undefined,
    undefined
  );

/*
 * @Description:
 * @LastEditors: LS
 * @Date: 2021-04-13 14:02:16
 */
class PubSub {
  constructor() {
    this._cacheList = {};
  }
  on(evtName, fn) {
    if (!this._cacheList[evtName]) {
      this._cacheList[evtName] = [];
    }
    this._cacheList[evtName].push(fn);
  }
  emit(evtName, data) {
    const fns = this._cacheList[evtName] || [];
    fns.forEach(fn => {
      fn(data);
    });
  }
  off(evtName, fns) {
    if (typeof fns === 'function') {
      fns = [fns];
    }
    if (fns) {
      fns.forEach(fn => {
        const index = this._cacheList[evtName].indexOf(fn);
        if (index !== -1) {
          this._cacheList[evtName].splice(index, 1);
        }
      });
    } else {
      this._cacheList[evtName] = [];
    }
  }
}
var pubSub = new PubSub();

/*
 * @Description:
 * @LastEditors: LS
 * @Date: 2021-04-21 15:36:25
 */
function getEleToDOMTop(ele, endDOM) {
  let top = 0;
  while (ele && ele.parentNode && ele !== endDOM) {
    top += ele.offsetTop;
    ele = ele.parentNode;
  }
  return top
}

//
var script$6 = {
  name: 'renderTable',
  props: {
    tableData: {
      type: Object,
    },
    scale: {
      type: Number,
    },
    tableType: {
      type: String,
    }
  },
  data() {
    return {
      trs: [],
      radio: 'all',
      copyTrs: [],
      rangSelect: {
        x1: 1,
        y1: 1,
        x2: this.tableData.row_num,
        y2: this.tableData.col_num,
      },
      buttonView: this.tableType === 'mark',
      // 首行是否设置为表头
      setColHead: false
    }
  },
  created() {
    const { cells } = this.tableData;
    cells.forEach(item => {
      if (!this.trs[item.row_index]) {
        this.trs[item.row_index] = [];
      }
      this.trs[item.row_index].push(item);
    });
  },
  computed: {
    wrapStyle() {
      return {
        ...this.tableData.positionStyle,
        outline: this.buttonView ? '2px solid rgba(4,134,254, 0.4)': 'none',
        'border-radius': '3px',
        color: 'transparent',
        'box-sizing': 'border-box',
      }
    }
  },
  mounted() {
    /**
     * 「Notice」
     *  这个append会转移已经存在html中节点，魔法技巧。。。
     * mounted时这个组件已经挂载在他定义的位置了。然后通过append进行转移
     */
    this.tableData.parentElement.append(this.$el);
  },
  methods: {
    /**
     * [Notice] 这里会给tdData增加一个是否被选的属性
     */
    generateStyle(tdData) {
      const scaleBbox = tdData.bbox.map(t => t * this.scale);
      let isSelect;
      if (this.radio !== 'part') {
        isSelect = false;
      } else {
        const { x1, x2, y1, y2 } = this.rangSelect;
        let { row_index, col_index } = tdData;
        // 对应跨的行数和列数，最少为1
        const { col_span, row_span } = tdData;
        row_index++;
        col_index++;
        // 如果跨行或者列了，需要加上
        isSelect = row_index + row_span - 1 >= x1 &&
            row_index <= x2 &&
            col_index + col_span - 1 >= y1 &&
            col_index <= y2;
        tdData.isSelect = isSelect;
      }
      return {
        width: scaleBbox[2] - scaleBbox[0] + 'px',
        height: scaleBbox[3] - scaleBbox[1] - 2 + 'px',
        textAlign: 'center',
        backgroundColor: isSelect ? '#ecf5ff' : 'transparent'
      }
    },
    getFixedTableData(trArr) {
      // 如果点击的是标注全部，直接设置为true
      const setColHead = this.radio === 'all' ? true : this.setColHead;

      // 目前只支持两维表头 需要修正表格的col_span
      const getHandledHead = (trArr, setColHead) => {
        const columnsArr = [];
        let headMerged = false;
        const tr0Map = {};
        trArr[0].forEach(item => {
          tr0Map[item.col_index] = item.text;
        });
        const tr1Map = {};
        trArr[1].forEach(item => {
          tr1Map[item.col_index] = item.text;
        });
        trArr[0].forEach((item) => {
          const { col_index, col_span, text } = item;
          if (col_span > 1 && setColHead) {
            headMerged = true;
          }
          let idx = 1;
          while (idx <= col_span) {
            const curIdx = col_index + idx - 1;
            const joinText = text + (tr1Map[curIdx] ? `_${tr1Map[curIdx]}` : '');
            columnsArr.push({
              index: String(curIdx),
              key_id: '',
              label: setColHead ? (joinText || '') : ''
            });
            idx++;
          }
        });
        return {
          columnsArr,
          headMerged
        }
      };

      const getDetailArr = ({ trArr, headMerged, setColHead }) => {
        const sliceIndex = headMerged ? 2 : (setColHead ? 1 : 0);
        const colDetailArr = [];
        trArr.slice(sliceIndex).forEach((tdArr, rowIdx) => {
          colDetailArr[rowIdx] = {};
          tdArr.forEach((item) => {
            colDetailArr[rowIdx][item.col_index] = item.text;
          });
        });
        return colDetailArr
      };

      const { columnsArr, headMerged } = getHandledHead(trArr, setColHead);
      const colDetailArr = getDetailArr({ trArr: trArr, headMerged, setColHead });
      const allColArr = getDetailArr({ trArr: trArr });

      return {
        detailArr: colDetailArr,
        columnsArr,
        allColArr,
        setColHead
      }
    },

    copyTable() {
      // 表示复制的是当前的表格
      const selection = document.getSelection();
      const range = document.createRange();
      range.selectNode(this.$refs.selectTable);
      selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand('copy');
      if (this.tableType === 'copy') {
        this.$message({
          type: 'success',
          message: '已复制到剪切板，可粘贴到文本编辑器或Excel中'
        });
      }
      window.getSelection().removeAllRanges();
      const tableInfo = this.getFixedTableData(this.copyTrs);
      const { pageNumber, tableBbox, parentElement, pageTableKey } = this.tableData;
      const tableObj = {
        table: tableInfo,
        page_num: pageNumber,
        table_index: pageTableKey,
        button: this.$refs.button,
        box: {
          left: tableBbox[2],
          bottom: tableBbox[3]
        },
        scrollTop: getEleToDOMTop(this.$refs.tableWrap, parentElement) / this.scale
      };
      // todo: 点击没有滚动到对应的位置，然后添加的时候，没有添加标签。
      pubSub.emit('add-table', tableObj);
      this.copyTrs = [];
    },

    handleCopyTable() {
      // 表示复制的是当前的表格
      const getSelectedTrArr = (trArr, noFilter) => {
        if (noFilter) {
          return trArr
        }
        const arr = trArr.map(tdArr => {
          return tdArr.filter(item => item.isSelect)
        }).filter(arr => arr.length > 0);
        return arr
      };
      this.copyTrs = getSelectedTrArr(this.trs, this.radio === 'all');
      this.$nextTick(() => {
        this.copyTable();
      });
    },
    handleView(bool) {
      this.buttonView = bool;
    },
  }
};

/* script */
const __vue_script__$6 = script$6;
/* template */
var __vue_render__$6 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      ref: "tableWrap",
      staticClass: "tableWrap",
      style: _vm.wrapStyle,
      attrs: { "data-page-table": _vm.tableData.pageTableKey },
      on: {
        mouseleave: function($event) {
          _vm.tableType === "copy" && _vm.handleView(false);
        },
        mousemove: function($event) {
          _vm.tableType === "copy" && _vm.handleView(true);
        }
      }
    },
    [
      _vm.buttonView
        ? _c(
            "div",
            { ref: "button", staticClass: "copy-wrap" },
            [
              _c(
                "el-popover",
                {
                  attrs: {
                    placement: "bottom",
                    width: "200",
                    trigger: _vm.tableType === "copy" ? "manual" : "hover"
                  }
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "el-radio",
                        {
                          staticClass: "pad-bottom10",
                          attrs: { label: "all" },
                          model: {
                            value: _vm.radio,
                            callback: function($$v) {
                              _vm.radio = $$v;
                            },
                            expression: "radio"
                          }
                        },
                        [_vm._v("\n          全部\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: "part" },
                          model: {
                            value: _vm.radio,
                            callback: function($$v) {
                              _vm.radio = $$v;
                            },
                            expression: "radio"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "inline-block" } },
                            [
                              _c(
                                "div",
                                { staticClass: "checkbox" },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: { disabled: _vm.radio === "all" },
                                      model: {
                                        value: _vm.setColHead,
                                        callback: function($$v) {
                                          _vm.setColHead = $$v;
                                        },
                                        expression: "setColHead"
                                      }
                                    },
                                    [_vm._v("首行设置为表头")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "rang-select" },
                                [
                                  _c("el-input", {
                                    staticClass: "input",
                                    attrs: {
                                      size: "mini",
                                      type: "number",
                                      min: "1",
                                      max: _vm.rangSelect.x2
                                    },
                                    model: {
                                      value: _vm.rangSelect.x1,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.rangSelect,
                                          "x1",
                                          _vm._n($$v)
                                        );
                                      },
                                      expression: "rangSelect.x1"
                                    }
                                  }),
                                  _vm._v("～\n              "),
                                  _c("el-input", {
                                    staticClass: "input",
                                    attrs: {
                                      size: "mini",
                                      type: "number",
                                      min: "1",
                                      max: _vm.tableData.row_num
                                    },
                                    model: {
                                      value: _vm.rangSelect.x2,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.rangSelect,
                                          "x2",
                                          _vm._n($$v)
                                        );
                                      },
                                      expression: "rangSelect.x2"
                                    }
                                  }),
                                  _vm._v("行\n            ")
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "rang-select" },
                                [
                                  _c("el-input", {
                                    staticClass: "input",
                                    attrs: {
                                      size: "mini",
                                      type: "number",
                                      min: "1",
                                      max: _vm.rangSelect.y2
                                    },
                                    model: {
                                      value: _vm.rangSelect.y1,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.rangSelect,
                                          "y1",
                                          _vm._n($$v)
                                        );
                                      },
                                      expression: "rangSelect.y1"
                                    }
                                  }),
                                  _vm._v("～\n              "),
                                  _c("el-input", {
                                    staticClass: "input",
                                    attrs: {
                                      size: "mini",
                                      type: "number",
                                      min: "1",
                                      max: _vm.tableData.col_num
                                    },
                                    model: {
                                      value: _vm.rangSelect.y2,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.rangSelect,
                                          "y2",
                                          _vm._n($$v)
                                        );
                                      },
                                      expression: "rangSelect.y2"
                                    }
                                  }),
                                  _vm._v("列\n            ")
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "button",
                      attrs: {
                        slot: "reference",
                        size: "mini",
                        type: "primary"
                      },
                      on: { click: _vm.handleCopyTable },
                      slot: "reference"
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.tableType === "copy" ? "复制表格" : "标注"
                          ) +
                          "\n      "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "table",
        {
          class: _vm.radio === "part" ? "table noselect show" : "table noselect"
        },
        [
          _c(
            "tbody",
            _vm._l(_vm.trs, function(tr, index) {
              return _c(
                "tr",
                { key: index },
                _vm._l(tr, function(td, index2) {
                  return _c(
                    "td",
                    {
                      key: index2,
                      style: _vm.generateStyle(td, index, index2),
                      attrs: { colSpan: td.col_span, rowSpan: td.row_span }
                    },
                    [_vm._v("\n          " + _vm._s(td.text) + "\n        ")]
                  )
                }),
                0
              )
            }),
            0
          )
        ]
      ),
      _vm._v(" "),
      _vm.copyTrs.length
        ? _c("div", { ref: "selectTable" }, [
            _c("table", [
              _c(
                "tbody",
                _vm._l(_vm.copyTrs, function(tr, index) {
                  return _c(
                    "tr",
                    { key: index },
                    _vm._l(tr, function(td, index2) {
                      return _c(
                        "td",
                        {
                          key: index2,
                          attrs: { colSpan: td.col_span, rowSpan: td.row_span }
                        },
                        [
                          _vm._v(
                            "\n            " + _vm._s(td.text) + "\n          "
                          )
                        ]
                      )
                    }),
                    0
                  )
                }),
                0
              )
            ])
          ])
        : _vm._e()
    ]
  )
};
var __vue_staticRenderFns__$6 = [];
__vue_render__$6._withStripped = true;

  /* style */
  const __vue_inject_styles__$6 = undefined;
  /* scoped */
  const __vue_scope_id__$6 = "data-v-69f3d5e0";
  /* module identifier */
  const __vue_module_identifier__$6 = undefined;
  /* functional template */
  const __vue_is_functional_template__$6 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$6 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$6, staticRenderFns: __vue_staticRenderFns__$6 },
    __vue_inject_styles__$6,
    __vue_script__$6,
    __vue_scope_id__$6,
    __vue_is_functional_template__$6,
    __vue_module_identifier__$6,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$7 = {
  name: 'renderImage',
  props: {
    imageData: {
      type: Object,
    },
    baseUrl: {
      type: String,
    },
  },
  data() {
    return {
      buttonView: false,
    }
  },
  mounted() {
    this.imageData.parentElement.append(this.$el);
  },
  computed: {
    wrapStyle() {
      return {
        ...this.imageData.positionStyle,
        position: 'absolute',
        outline: this.buttonView ? '2px solid rgba(4,134,254, 0.4)': 'none',
        color: 'transparent',
        'box-sizing': 'border-box',
        'border-radius': '3px',
        'z-index': 1000,
      }
    }
  },
  methods: {
    handleView(bool) {
      this.buttonView = bool;
    },
    onDownload() {
      const srcImg = this.baseUrl + this.imageData.filename;
      this.upload(srcImg);
    },
    upload(srcImg) {
      const image = new Image();
      // 解决跨域 canvas 污染问题
      // image.setAttribute("crossOrigin", "anonymous");
      image.crossOrigin = 'Anonymous';
      const fileName = this.imageData.name;
      image.onload = function () {
        const canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        const context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, image.width, image.height);
        // 得到图片的base64编码数据
        const url = canvas.toDataURL('image/png');
        // 生成一个 a 标签
        const a = document.createElement('a');
        // 创建一个点击事件
        const event = new MouseEvent('click');
        // 将 a 的 download 属性设置为我们想要下载的图片的名称，若 name 不存在则使用'图片'作为默认名称
        a.download = fileName || '图片';
        // 将生成的 URL 设置为 a.href 属性
        a.href = url;
        // 触发 a 的点击事件
        a.dispatchEvent(event);
        // return a;
      };
      image.src = srcImg;
    },
  }
};

/* script */
const __vue_script__$7 = script$7;
/* template */
var __vue_render__$7 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      ref: "imagesWrap",
      style: _vm.wrapStyle,
      attrs: { "data-page-table": _vm.imageData.pageTableKey },
      on: {
        mouseleave: function($event) {
          return _vm.handleView(false)
        },
        mousemove: function($event) {
          return _vm.handleView(true)
        }
      }
    },
    [
      _vm.buttonView
        ? _c(
            "div",
            { staticStyle: { position: "absolute", right: "0", top: "0" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.onDownload }
                },
                [_vm._v("下载图片")]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
};
var __vue_staticRenderFns__$7 = [];
__vue_render__$7._withStripped = true;

  /* style */
  const __vue_inject_styles__$7 = undefined;
  /* scoped */
  const __vue_scope_id__$7 = "data-v-65baed16";
  /* module identifier */
  const __vue_module_identifier__$7 = undefined;
  /* functional template */
  const __vue_is_functional_template__$7 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$7 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$7, staticRenderFns: __vue_staticRenderFns__$7 },
    __vue_inject_styles__$7,
    __vue_script__$7,
    __vue_scope_id__$7,
    __vue_is_functional_template__$7,
    __vue_module_identifier__$7,
    false,
    undefined,
    undefined,
    undefined
  );

//

var script$8 = {
  name: 'pdf-view',
  components: {
    PdfDirectory: __vue_component__$5,
    ControlBar: __vue_component__$3,
    PdfTable: __vue_component__$6,
    PdfImage: __vue_component__$7
  },
  props: {
    htmlJSON: { // html 数据
      type: Object,
    },
    tableJSON: { // html内部的table数据
      type: Array,
    },
    filePath: {
      type: String,
      required: true
    },
    baseUrl: {
      type: String,
    },
    id: {
      type: String,
      default: 'pdf-view-content'
    },
    directoryPos: {
      type: String,
      default: 'left',
      validator: function (value) {
        // 这个值必须匹配下列字符串中的一个
        return ['left', 'right'].indexOf(value) !== -1
      }
    },
    showConfig: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      totalPageNum: '',
      tableMap: {}, // 文档中的渲染的table数据，将这些table数据以表格形式渲染出来。
      curPageNum: 1,
      directoryData: null, // 目录结构数据
      showScale: 1, // 这个是页面进行展示的比例
      viewportScale: 1, // 这个是页面内字体的缩放比例
      initScale: 0, // 依据页面大小pdfView进行自动缩放，会有一个初始的scale
      imageData: [],
      imageMap: {},
    }
  },
  created() {
    this.pdfViewInstance = new PdfView({
      id: this.id,
    });
  },
  async mounted() {
    this.pdfViewInstance.initViewer(this.filePath, (scale) => {
      this.initScale = scale;
      this.$emit('pdfRendered', {
        pdfViewInstance: this.pdfViewInstance
      });
      pubSub.emit('pdf-rendered', {
        pdfViewInstance: this.pdfViewInstance
      });
      this.$emit('changeZoom', scale);
      pubSub.emit('change-zoom', scale);
    });

    /** 监听页面修改事件 */
    this.pdfViewInstance.addPageChangeEvt((page) => {
      this.curPageNum = page;
    });
    /**
     * 监听每页面渲染事件
     */
    this.pdfViewInstance.addPageRenderEvt((num, textLayerDiv, viewport) => {
      this.$emit('pdfPageRender', num, textLayerDiv, viewport);
      pubSub.emit('pdf-page-render', num, textLayerDiv, viewport);
    });
  },
  methods: {
    handleTableData(pages) {
      this.tableData = [];

      const mapTable = (t) => {
        return t.tables.map((child, index) => {
          if (!child.features.chart) {
            child.name = 'table' + (index + 1);
            child.key = 'page' + t.number + 'child' + index;
            child.toTop = (t.bbox[3] - child.bbox[3]);
            child.number = t.number;
            return child
          } else {
            return null
          }
        }).filter(item => item)
      };

      pages.map(t => {
        t.name = `[page][${t.number}]`;
        t.key = 'page' + t.number;
        const { tables } = t;
        if (tables && tables.length) {
          this.tableData.push({
            ...t,
            children: mapTable(t)
          });
        }
        if (t.body) {
          t.body.blocks.map(item => {
            if (item.tables && item.tables.length) {
              t.children = mapTable({ ...item, number: t.number });
              this.tableData.push(t);
            }
            return item
          });
        }
      });
      return this.tableData
    },

    handleImageData(pages) {
      this.imageData = [];
      pages.map(t => {
        t.name = `[page][${t.number}]`;
        t.key = 'page' + t.number;
        if (t.body) {
          const children = [];
          t.body.blocks.forEach(item => {
            const { tables } = item;
            if (tables && tables.length) {
              // item = {...item, number: t.number}
              const { tables } = item;
              const figuresForEach = (figures) => {
                figures.forEach(figure => {
                  const index = children.length;
                  figure.name = figure.title ? figure.title.text : 'image' + (index + 1);
                  figure.key = 'page' + t.number + 'child' + index;
                  figure.toTop = (t.bbox[3] - figure.bbox[3]);
                  figure.number = t.number;
                  children.push({ ...figure });
                });
              };
              tables.forEach(child => {
                const { cells } = child;
                cells.forEach(cell => {
                  figuresForEach(cell.figures);
                });
              });
              if (item.figures && item.figures.length) {
                figuresForEach(item.figures);
              }
            }
            return item
          });
          if (children.length) {
            this.imageData.push({ ...t, children });
          }
        }
      });
      return this.imageData
    },

    handleDocData(data, pageBbox) {
      data.filter(item => item.type === 'table').map((item, i) => {
        item.viewIndex = i + 1;
      });
      return data.map((t) => {
        if (t.type === 'table') {
          t.name = `table{${t.viewIndex}}`;
        }
        if (t.type === 'title') {
          t.name = t.data ? t.data.text : '<' + '封面' + '>';
        }
        t.key = t.id || 0;
        t.number = t.page_number;
        if (t.data && t.data.textlines && t.data.textlines.length) {
          const bbox = t.data.textlines[0].bbox;
          t.toTop = pageBbox[3] - bbox[3];
        }
        if (t.data && t.data.bbox) {
          t.toTop = pageBbox[3] - t.data.bbox[3];
        }
        if (t.children) {
          t.children = t.children.filter(item => (item.type !== 'section' && item.type !== 'figure'));
          this.handleDocData(t.children, pageBbox);
        }
        return t
      })
    },

    renderTable(tableData) {
      this.pdfViewInstance.addPageRenderEvt((pageNumber, textLayerDiv, viewport) => {
        const currentTables = tableData.find(t => t.number === (pageNumber));
        this.viewportScale = viewport.scale;
        // 提出的scale不同的key
        for (const key in this.tableMap) {
          const scale = key.split('_')[0];
          if (scale !== String(this.viewportScale)) {
            this.$delete(this.tableMap, key);
          }
        }
        if (currentTables && currentTables.children) {
          currentTables.children.forEach((table, index) => {
            const tableBbox = table.bbox.map(box => box * viewport.scale);
            const item = {
              ...table,
              positionStyle: {
                top: viewport.height - tableBbox[3] - 4 + 'px',
                right: viewport.width - tableBbox[2] - 4 + 'px',
                left: tableBbox[0] - 2 + 'px',
                bottom: tableBbox[1] - 2 + 'px',
              },
              tableBbox,
              parentElement: textLayerDiv.parentElement,
              pageTableKey: index,
              pageNumber,
              scale: this.viewportScale
            };
            this.$set(this.tableMap, `${this.viewportScale}_${pageNumber}_${index}`, item);
          });
        }
      });
    },

    renderImage(imageData) {
      this.pdfViewInstance.addPageRenderEvt((pageNumber, textLayerDiv, viewport) => {
        const currentImages= imageData.find(t => t.number === (pageNumber));
        this.viewportScale = viewport.scale;
        // 提出的scale不同的key
        for (const key in this.imageMap) {
          const scale = key.split('_')[0];
          if (scale !== String(this.viewportScale)) {
            this.$delete(this.imageMap, key);
          }
        }
        if (currentImages && currentImages.children) {
          currentImages.children.forEach((table, index) => {
            const tableBbox = table.bbox.map(box => box * viewport.scale);
            const item = {
              ...table,
              positionStyle: {
                top: viewport.height - tableBbox[3] - 4 + 'px',
                right: viewport.width - tableBbox[2] - 4 + 'px',
                left: tableBbox[0] - 2 + 'px',
                bottom: tableBbox[1] - 2 + 'px',
              },
              tableBbox,
              parentElement: textLayerDiv.parentElement,
              pageTableKey: index,
              pageNumber,
              scale: this.viewportScale
            };
            this.$set(this.imageMap, `${this.viewportScale}_${pageNumber}_${index}`, item);
          });
        }
      });
    },

    setZoom(showScale) {
      /**
       * 这里要等他初始化好了才能执行呀
       */
      this.showScale = showScale;
      const realScale = this.showScale * this.initScale;
      this.pdfViewInstance.setZoom(realScale);
      this.$emit('changeZoom', realScale);
      pubSub.emit('change-zoom', realScale);
    },

    setPage(pageNumber, toTop = 0) {
      this.pdfViewInstance.setPage(pageNumber, toTop * this.showScale);
    },
  },
  computed: {
    compShowConfig() {
      const { directoryShow = true, tableType = true, imageShow = false } = this.showConfig || {};
      return {
        directoryShow, tableType, imageShow
      }
    }
  },
  watch: {
    htmlJSON: {
      handler(nextData) {
        if (nextData) {
          this.totalPageNum = nextData.pages.length;
          const bbox = nextData.pages[0].bbox;
          this.directoryData = this.handleDocData([nextData.tree.root], bbox);
        }
      },
      immediate: true,
    },
    tableJSON(nextData) {
      if (this.compShowConfig.tableType) {
        this.renderTable(this.handleTableData(nextData));
      }
      if (this.compShowConfig.imageShow) {
        this.renderImage(this.handleImageData(nextData));
      }
    },
  }
};
const PdfBus = pubSub;

/* script */
const __vue_script__$8 = script$8;
/* template */
var __vue_render__$8 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "pdf-wrap" }, [
    _c(
      "div",
      { class: _vm.directoryPos === "left" ? " pdf-view" : "dir-rtl pdf-view" },
      [
        _vm.compShowConfig.directoryShow
          ? _c("PdfDirectory", {
              attrs: {
                pos: _vm.directoryPos,
                jumpPage: _vm.setPage,
                data: this.directoryData
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "view-wrap" },
          [
            _c("ControlBar", {
              attrs: {
                totalPageNum: _vm.totalPageNum,
                curPageNum: _vm.curPageNum,
                showScale: _vm.showScale,
                setZoom: _vm.setZoom,
                setPage: _vm.setPage
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pdf-view-class", attrs: { id: _vm.id } },
              [_c("div", { staticClass: "pdfViewer" })]
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm.tableJSON
      ? _c(
          "div",
          [
            _vm._l(_vm.tableMap, function(item) {
              return _c("PdfTable", {
                key: item.key + "_" + item.scale,
                ref: "tableView" + item.bbox.toString(),
                refInFor: true,
                attrs: {
                  tableType: _vm.compShowConfig.tableType,
                  tableData: item,
                  scale: _vm.viewportScale
                }
              })
            }),
            _vm._v(" "),
            _vm._l(_vm.imageMap, function(item) {
              return _c("PdfImage", {
                key: item.key + "_" + item.scale,
                ref: "imageView" + item.bbox.toString(),
                refInFor: true,
                attrs: {
                  imageData: item,
                  baseUrl: _vm.baseUrl,
                  scale: _vm.viewportScale
                }
              })
            })
          ],
          2
        )
      : _vm._e()
  ])
};
var __vue_staticRenderFns__$8 = [];
__vue_render__$8._withStripped = true;

  /* style */
  const __vue_inject_styles__$8 = undefined;
  /* scoped */
  const __vue_scope_id__$8 = "data-v-4178fcc8";
  /* module identifier */
  const __vue_module_identifier__$8 = undefined;
  /* functional template */
  const __vue_is_functional_template__$8 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$8 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$8, staticRenderFns: __vue_staticRenderFns__$8 },
    __vue_inject_styles__$8,
    __vue_script__$8,
    __vue_scope_id__$8,
    __vue_is_functional_template__$8,
    __vue_module_identifier__$8,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__$8;
export { PdfBus };
